import _ from 'lodash';

export const DEFAULT_STATE = [];

export default function (state = DEFAULT_STATE, action) {
    switch (action.type) {
        case 'NotificationPreferenceActions.ON_GET':
        case 'NotificationPreferenceActions.ON_SAVE':
            return _.cloneDeep(action.result);
    }

    return state;
}
